module.exports = {
  'contents-1': {
    translateY: [ 0, -300 ],
  },
};



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/pc/ui/parallax-option.js
 **/